export const OrganizationHead = {
    img: require("../../../images/orgbannerimage.png"),
    heading: "ORGANIZATION STRUCTURE",
    lightText: true,
};

export const OrgData = {
    "img": require("../../../images/image 28.png"),
}